module.exports = __webpack_public_path__ + "static/media/06_.94863a7d.png";